module.exports = __webpack_public_path__ + "assets/img/6.c9a8bb9b.jpg";